import {LOCALE_ID, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {es_ES, NzI18nService, provideNzI18n} from 'ng-zorro-antd/i18n';
import {registerLocaleData} from '@angular/common';
import localeEs from '@angular/common/locales/es';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptors} from '@angular/common/http';
import {SharedModule} from '@app/shared';
import {NzContentComponent, NzLayoutComponent} from 'ng-zorro-antd/layout';
import {AuthInterceptor, AuthModule, LogLevel} from 'angular-auth-oidc-client';
import {environment} from '../environments/environment';
import {NzCardComponent} from 'ng-zorro-antd/card';
import {LayoutsModule} from "./layouts/layouts.module";
import {standarizeErrorsInterceptor} from './core/interceptors/standarize-errors.interceptor';
import {es} from 'date-fns/locale';

registerLocaleData(localeEs, 'es');

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    NzLayoutComponent,
    NzContentComponent,
    AuthModule.forRoot({
      config: {
        authority: environment.production ? 'https://sso.mojito360.com/' : 'https://sso.pre.mojito360.com/',
        redirectUrl: window.location.origin + '/auth/callback',
        postLogoutRedirectUri: window.location.origin,
        clientId: 'sourtrack_web',
        scope: 'sourtrack_api openid profile email offline_access',
        responseType: 'code',
        silentRenew: true,
        useRefreshToken: true,
        renewTimeBeforeTokenExpiresInSeconds: 120,
        triggerRefreshWhenIdTokenExpired: true,
        silentRenewTimeoutInSeconds: 30,
        refreshTokenRetryInSeconds: 2,
        // En produccion el modo Debug vuelca en consola el detalle del login y la renovacion de tokens.
        logLevel: environment.production ? LogLevel.Warn : LogLevel.Debug,
        secureRoutes: [environment.baseUrl],
      }
    }),
    NzCardComponent,
    LayoutsModule,
  ],
  providers: [
    {provide: LOCALE_ID, useValue: 'es_ES'},
    provideNzI18n(es_ES),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([standarizeErrorsInterceptor])),
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private i18n: NzI18nService) {
    // Configurar primer día de la semana globalmente
    this.configureFirstDayOfWeek();
  }

  private configureFirstDayOfWeek() {


    const customLocale = {
      ...es, // Usa locale en español
      options: {
        weekStartsOn: 1 as 1, // 1 = Lunes, 0 = Domingo
      }
    };

    // Aplicar configuración global
    this.i18n.setDateLocale(customLocale);
  }
}
